import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import tinycolor from 'tinycolor2';

const ActivatableTr = styled(
  ({
    isActive,
    isSelected,
    hover,
    isTableHovered,
    activeColor,
    scrollProps = {},
    ...props
  }) => {
    const row = useRef(null);
    useEffect(() => {
      if (isActive && !isTableHovered && row.current) {
        row.current.scrollIntoView({ block: 'center', ...scrollProps });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isActive, isTableHovered]);
    return <tr ref={row} {...props} />;
  },
)`
  ${({ isActive, isSelected, activeColor, hover }) => {
    if (isActive && hover) {
      return 'background-color: var(--active-hover);';
    }
    return (
      (isActive || isSelected) &&
      `
        background-color: ${
          activeColor
            ? tinycolor(activeColor).setAlpha(0.3).toRgbString()
            : 'rgba(33, 33, 33, 0.05)'
        };
      `
    );
  }}}
  ${({ onClick }) => !!onClick && 'cursor: pointer !important;'}
`;

export default ActivatableTr;
